import Phaser from "phaser";
import { BottomNavBtn } from "@phaser/ui/navs/BottomNavBtn";
import type { NavSceneType } from "@phaser/ui/navs/BottomNavBtn";

// 하단 네비게이션 바 클래스 정의
export class BottomNavBar extends Phaser.GameObjects.Container {
  static preload(scene: Phaser.Scene) {
    BottomNavBtn.preload(scene);
  }

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    current: NavSceneType,
  ) {
    super(scene, x, y);
    scene.add.existing(this);

    const gap = 256;

    // ShopScene 버튼 생성
    const shopBtn = new BottomNavBtn(scene, -gap, -60, {
      targetScene: "ShopScene",
      isActive: current === "SHOP",
      defaultKey: "nav-shop",
      activeKey: "nav-shop-active",
    });

    // HomeScene 버튼 생성
    const homeBtn = new BottomNavBtn(scene, 0, -60, {
      targetScene: "HomeScene",
      isActive: current === "HOME",
      defaultKey: "nav-home",
      activeKey: "nav-home-active",
    });

    // CodexScene 버튼 생성
    const codexBtn = new BottomNavBtn(scene, gap, -60, {
      targetScene: "CodexScene",
      isActive: current === "CODEX",
      defaultKey: "nav-codex",
      activeKey: "nav-codex-active",
    });

    this.add([shopBtn, homeBtn, codexBtn]);
    this.setDepth(10);
  }
}
